import HumintLayoyt from '@/views/humint/components/layout.vue';
export const humint = {
  path: '/humint',
  component: HumintLayoyt,
  redirect: '/humint/index',
  meta: {
    title: '人才资源库'
  },
  children: [
    {
      path: 'index',
      name: '首页搜索',
      component: () => import(/* webpackChunkName: "project" */ '@/views/humint/index.vue'),
      meta: {
        title: '人才库首页'
      }
    },
    {
      path: '/humint/demand',
      name: '找人需求',
      component: () => import(/* webpackChunkName: "project" */ '@/views/humint/demand.vue'),
      meta: {
        title: '人才库首页-我的找人需求'
      }
    },
    {
      path: '/humint/demand/feedbackInfo',
      component: () => import(/* webpackChunkName: "project" */ '@/views/humint/feedbackInfo.vue')
    },
    {
      path: '/humint/clue',
      name: '线索管理',
      component: () => import(/* webpackChunkName: "project" */ '@/views/humint/clue.vue')
    },
    {
      path: '/humint/clue/recommend',
      component: () => import(/* webpackChunkName: "project" */ '@/views/humint/clue-recommend.vue')
    }
  ]
};
